module.exports = __webpack_public_path__ + "static/intellisense-c349fd8b3f5b73e7e7a9b4731c1edc37.png";